module.exports = __webpack_public_path__ + "img/classic.40ca82b9.png";